import { Button, ButtonProps, LinearProgress, Stack, SxProps, Theme } from '@mui/material'
import { ReactNode, type JSX } from 'react'

interface Props extends ButtonProps {
  isPending?: boolean
  children?: ReactNode
  isRounded?: boolean
  sx?: SxProps<Theme>
}

const AsyncActionButton = ({ isPending, disabled, isRounded, children, sx, ...otherProps }: Props): JSX.Element => {
  return (
    <Button
      type="button"
      {...otherProps}
      disabled={isPending || disabled}
      sx={[
        isRounded
          ? {
              borderRadius: '1rem',
            }
          : {
              borderRadius: null,
            },
        // https://mui.com/system/getting-started/the-sx-prop/#passing-the-sx-prop
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      <Stack>
        {isPending && <LinearProgress />}
        {children}
      </Stack>
    </Button>
  )
}

export default AsyncActionButton
